import {Component, Input} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';

@Component({
  standalone: true,
  selector: 'mc-slack-notification',
  templateUrl: './slack-notification.component.html',
  styleUrls: ['./slack-notification.component.scss'],
  imports: [MatButtonModule, MatIconModule],
})
export class SlackNotificationComponent {
  @Input() url: string;
  @Input() message: string;
}
